import { render } from "./new-role.vue?vue&type=template&id=68e7ea30"
import script from "./new-role.vue?vue&type=script&lang=js"
export * from "./new-role.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__